import type Application from "../../types/application";
import { Body } from "@sprout/typography";
import PreviewIcon from "@sprout/icons/preview";
import EllipsisIcon from "@sprout/icons/ellipsis";
import { Row } from "@sprout/layout";
import useTranslation from "@hooks/use_translation";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@components/ui/dropdown-menu.tsx";
import { useEffect, useState } from "react";
import { MarkInactiveModal } from "@components/applications/mark_inactive_modal.tsx";
import { IconButton } from "@sprout/icon_button.tsx";

type Props = {
  application: Application;
  hasTokens: boolean;
  onAddDreamJob: () => void;
};

const ApplicationEllipsis = ({ application }: Props) => {
  const { t } = useTranslation("applications");

  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isMarkInactiveModalOpen, setIsMarkInactiveModalOpen] = useState(false);

  useEffect(() => {
    if (!isMarkInactiveModalOpen) {
      return;
    }

    setIsDropdownOpen(false);
  }, [isMarkInactiveModalOpen]);

  return (
    <>
      <DropdownMenu open={isDropdownOpen} onOpenChange={setIsDropdownOpen}>
        <DropdownMenuTrigger asChild>
          <IconButton label="Open menu" icon={EllipsisIcon} size="md" />
        </DropdownMenuTrigger>
        <DropdownMenuContent className="w-74" align="end">
          <DropdownMenuItem
            onSelect={() => {
              window.open(application.job_post_url, "_blank");
            }}
          >
            <Row align="center" gap={"12px"}>
              <Body>{t("dream_job.open_job_post")}</Body>
              <PreviewIcon />
            </Row>
          </DropdownMenuItem>
          {!application.inactive && (
            <DropdownMenuItem onSelect={() => setIsMarkInactiveModalOpen(true)}>
              <Body>{t("mark_as_inactive")}</Body>
            </DropdownMenuItem>
          )}
        </DropdownMenuContent>
      </DropdownMenu>
      <MarkInactiveModal
        application={application}
        open={isMarkInactiveModalOpen}
        onOpenChange={setIsMarkInactiveModalOpen}
      />
    </>
  );
};

export default ApplicationEllipsis;
